import axios from "axios";
import { supabase } from "./Supabase";
const API_URL = process.env.REACT_APP_API_URL

const StoriesService = {
    getStories: async function() {
        const response = await axios.get(`${API_URL}/stories`, null, {
            crossDomain: true,
        });
        console.log(response);
        return response.data;
    },

    getStory: async function(id) {
        const response = await axios.get(`${API_URL}/stories/${id}`, null, { 
            params: {
                id
            },
            crossDomain: true,
        });
        console.log(response);
        return response.data;
    },

    addStory: async function(order, url, title, subtitle = null, thumbnail = null) {
        const data = {order, url, title, subtitle}
        console.log("New story:");
        console.log(data);
        const response = await axios.post(`${API_URL}/stories`, data, { 
            crossDomain: true,
        });
        if(thumbnail && thumbnail.size !== 0)
            await supabase.storage.from('thumbnails').upload(`${response.data.id}`, thumbnail)
        console.log(response);
        
        return response.data;
    },

    updateStory: async function(id, order = null, url = null, title = null, subtitle = null, thumbnail = null) {
        const data = {id, order, url, title, subtitle}
        console.log("thumbnail");
        console.log(JSON.stringify(thumbnail));
        if(thumbnail && thumbnail.size !== 0) {
            const result = await supabase.storage.from('thumbnails').upload(`${id}`, thumbnail, {
                upsert: true
            });
            console.log("Upload result");
            console.log(JSON.stringify(result, null, 4));
        }
        const response = await axios.put(`${API_URL}/stories/${id}`, data, { 
            crossDomain: true,
        });
        console.log(response);
        
        
        return response.data;
    },

    deleteStory: async function(id) {
        const response = await axios.delete(`${API_URL}/stories/${id}`, null, { 
            params: {
                id
            },
            crossDomain: true,
        });
        console.log(response);
        return response.data;
    },

    updateStoryOrders: async function(stories) {
        const response = await axios.put(`${API_URL}/stories/order`, stories, {
            crossDomain: true
        });
        console.log(response);
        return response;
    }
};

export default StoriesService;